import * as API from "@/services/API";

export default {
  getSliders() {
    return API.apiClient.get("/homepage-slider-images");
  },
};
